import type { PostMarketingRequest, PostMarketingResponse } from './types';
import { postGenericEndpoint, type PostGenericEndpointParams } from './post.api';

export const postMarketing = async ({ data, lang, token }: PostGenericEndpointParams<PostMarketingRequest>): Promise<PostMarketingResponse> => {
    return await postGenericEndpoint({
        data,
        lang,
        token,
        path: 'marketing',
    });
};
